import { useEffect, useState } from 'react';
import { ItemHistoryLineItem, ItemHistoryLineType } from './item-types';
import TableWrapperBase from '../shared/table';
import { dataTypes } from '../shared/table-helpers';
import { ItemAPI } from '../../api/item';
import { CircularProgress, Stack } from '@mui/material';
const TableWrapper = TableWrapperBase as any;

export interface ItemHistoryLineTableProps {
  historyType: ItemHistoryLineType;
  year: number;
  month: number;
  itemId: string;
  locationId: number;
  extraColumns?: any[];
}
export default function ItemHistoryLineTable(props: ItemHistoryLineTableProps) {
  const [lineItems, setLineItems] = useState<ItemHistoryLineItem[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  useEffect(() => {
    const get = async () => {
      if (!props?.historyType) {
        setLineItems([]);
        return;
      }
      setIsLoading(true);
      const data = await ItemAPI.getItemHistoryDetails({
        year: props.year,
        month: props.month,
        itemID: props.itemId,
        historyType: props.historyType,
        locationId: props.locationId,
      });

      setLineItems(data.data);
      setIsLoading(false);
    };
    get();
  }, [props.year, props.month, props.itemId, props.historyType]);

  const columns = [
    {
      id: 'date_created',
      label: 'Date',
      dataType: dataTypes.date,
    },
    {
      id: 'quantity',
      label: 'Quantity',
      dataType: dataTypes.number,
    },
    ...(props?.extraColumns ?? []),
    { id: 'price', label: 'Price', dataType: dataTypes.currency },
  ];
  return isLoading ? (
    <Stack sx={{ width: '100%', paddingY: 2 }} alignItems={'center'}>
      <CircularProgress />
    </Stack>
  ) : (
    <TableWrapper transformRows columns={columns} rows={lineItems} />
  );
}
